import styled from 'styled-components'
import { TransitionsAnim } from 'animations/Transitions'

interface LOADER_STYLED_PROPS {
  colors: any
}
const { loaderDotScale } = TransitionsAnim()

export const LoaderDiv = styled.div<LOADER_STYLED_PROPS>`
  width: 100%;
  height: calc(100% - 56px);
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 30px;
    color: ${({ colors }) => colors.secondary};
    display: flex;
    justify-content: center;
    align-items: baseline;
    text-transform: uppercase;
  }
  span {
    width: 7px;
    height: 7px;
    background: ${({ colors }) => colors.secondary};
    border-radius: 50%;
    margin: 0 5px;
    ${loaderDotScale};
    :nth-child(1) {
      animation-delay: 0s;
    }
    :nth-child(2) {
      animation-delay: 0.25s;
    }
    :nth-child(3) {
      animation-delay: 0.5s;
    }
  }
`
